import React from 'react'

import Icon from '../../icon'

import * as S from './styles'

import IProps from './props'

const Selections: React.FC<IProps> = ({ selections, onDelete }) => (
  <S.SelectionsContainer>
    {selections.map((selection) => (
      <S.Selection key={selection}>
        {selection}
        <Icon name="close" onClick={() => onDelete(selection)} />
      </S.Selection>
    ))}
  </S.SelectionsContainer>
)

export default Selections
